import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'mage-deps/@klarna/mp-ui'

const Dialog = ({ portal = true, closeOnClickOutside = true, useWindowHeight = false, closeOnEscape = true, children, ...props }) => {
  return (
    <Modal
      usePortal={portal}
      closeOnClickOutside
      closeOnEscape
      useWindowHeight
      {...props}
    >
      {children}
    </Modal>
  )
}

Dialog.propTypes = {
  onClose: PropTypes.func,
  closeOnClickOutside: PropTypes.bool,
  useWindowHeight: PropTypes.bool,
  closeOnEscape: PropTypes.bool,
  large: PropTypes.bool,
  portal: PropTypes.bool,
  id: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  footer: PropTypes.array,
  unwrapped: PropTypes.bool
}

export default Dialog
